<div class="sidebar-footer-actions px-3 pb-2">
  <PlatformSwitcher />
</div>

<router-link
  to="/profile"
  class="user-section px-3 py-3 d-flex align-items-center border-top border-white border-opacity-10 text-decoration-none"
  aria-label="Open profile"
  title="Open profile"
>

  <!-- Avatar Circle -->
  <div class="user-avatar rounded-circle me-2 flex-shrink-0 d-flex justify-content-center align-items-center text-white fw-light avatar-size">
    {{ initials }}
  </div>

  <!-- Full Name -->
  <div class="flex-grow-1 min-w-0 sidebar-menu-text">
    <p class="text-white fw-bold text-xs mt-3 text-truncate">{{ full_name }}</p>
  </div>

</router-link>
